export default __webpack_public_path__ + "static/media/4.85af65c2.png";